<template>
  <div>
		<dig-autocomplete @OnSelected=OnSelected :endpoint="endpoint" :tag="tag" :filterItems="value" v-model="inputValue"></dig-autocomplete>
		<div style="display:flex;">
			<div style="display:flex;border: 1px solid #d7d7d7;padding:5px;margin-right:5px;" v-for="(item, index) in value" :key="index">
				<div style="margin-right:5px;cursor:pointer;" @click="OnDeleted(index)"><i class="fa fa-close"></i></div>
				<div>{{item.name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AutoComplete from './autocomplete.vue'

export default {
  	components : {
		'dig-autocomplete' : AutoComplete
	},
	props: {
		value:{type:Array, default: function () { return [] }},
		endpoint:String,
		tag:String,
	},
	methods: {
		OnDeleted:function(index) {
			var temp = this.value.slice();
			Vue.delete(temp, index);
			this.$emit('input', temp);
		},
		OnSelected:function(item) {
			var temp = this.value.slice();
			temp.push(item);
			this.$emit('input', temp);
			this.inputValue = '';
		}
	},
	data() {
		return {
			inputValue:'',
		}
	},
}
</script>

<style scoped>
</style>
